import coverBaltiptsy from "../../assets/tiptsy2.webp";
import coverTsapwak from "../../assets/tiptsy3.webp";
import coverJajtaaky from "../../assets/tiptsy4.webp";
import coverBaltiptsyLive from "../../assets/tiptsy5.webp";

export interface Track {
  id: string;
  title: string;
  titleKey: string;
  subtitleKey: string;
  descriptionKey: string;
  src: string;
  cover: string;
}

// Agrega futuras canciones aquí. El reproductor y la lista se actualizan automáticamente.
export const tracks: Track[] = [{
  id: "baltiptsy-original",
  title: "Baltiptsy",
  titleKey: "player.tracks.baltiptsyOriginal.title",
  subtitleKey: "player.tracks.baltiptsyOriginal.subtitle",
  descriptionKey: "player.tracks.baltiptsyOriginal.description",
  src: "/audio/baltiptsy-original.mp3",
  cover: coverBaltiptsy
}, {
  id: "tsapwak",
  title: "Tsapwäk",
  titleKey: "player.tracks.tsapwak.title",
  subtitleKey: "player.tracks.tsapwak.subtitle",
  descriptionKey: "player.tracks.tsapwak.description",
  src: "/audio/tsapwak.mp3",
  cover: coverTsapwak
}, {
  id: "jajtaaky",
  title: "Jäjtääky",
  titleKey: "player.tracks.jajtaaky.title",
  subtitleKey: "player.tracks.jajtaaky.subtitle",
  descriptionKey: "player.tracks.jajtaaky.description",
  src: "/audio/jajtaaky.mp3",
  cover: coverJajtaaky
}, {
  id: "baltiptsy-live",
  title: "Baltiptsy",
  titleKey: "player.tracks.baltiptsyLive.title",
  subtitleKey: "player.tracks.baltiptsyLive.subtitle",
  descriptionKey: "player.tracks.baltiptsyLive.description",
  src: "/audio/Baltiptsy.mp3",
  cover: coverBaltiptsyLive
}];
